import React, { useState, useEffect } from 'react';
import { Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useMessageResources } from '../../../language';
import { onWarning } from '../messages';

const TextInput = ({
  value: propValue,
  onBlur,
  onChange,
  maxCharacters,
  ...rest
}) => {
  const [localValue, setLocalValue] = useState(propValue || '');
  const msg = useMessageResources();

  useEffect(() => {
    setLocalValue(propValue || '');
  }, [propValue]);

  const handleBlur = () => {
    if (onBlur) onBlur(localValue);
  };

  const handleChange = (e, { value }) => {
    if (maxCharacters && value.length > maxCharacters) {
      onWarning(msg('MaxCharactersReached').replace('{0}', maxCharacters));
      return;
    }

    setLocalValue(value);
    if (onChange) onChange(value);
  };

  return (
    <Input
      value={localValue}
      onBlur={handleBlur}
      onChange={handleChange}
      {...rest}
    />
  );
};

TextInput.propTypes = {
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  maxCharacters: PropTypes.number,
};

export default TextInput;
